import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, onBeforeMount } from "vue";
import { getTheme, setTheme } from "@/composables/useTheme";
import { useLayout } from "@/composables/useLayout";
import { addResizeListener } from '@/helpers/utils';
import { getStaffList } from "@/composables/useStaff";
import { getServices } from "@/composables/useServices";
import { getAboutData } from "@/composables/useAbout";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { setLayout } = useLayout();
onBeforeMount(() => {
  setLayout();
  getStaffList();
  getServices();
  getAboutData();
});
onMounted(() => {
  setTheme(getTheme().name, getTheme().size);
  addResizeListener();
},)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})